import React, { useRef } from "react";
import "./Contact.css";

import emailjs from "@emailjs/browser";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const form = useRef();

  function sendEmail(e) {
    e.preventDefault();
    const serviceid = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    emailjs
      .sendForm(serviceid, templateId, form.current, {
        publicKey: publicKey,
      })
      .then(
        (response) => {
          if (response.status === 200) {
            toast.success("Message sent successfully!");
            form.current.reset();
          }
        },
        (error) => {
          console.log("FAILED...", error.text, error);
        }
      );
  }

  return (
    <>
      <section className="contact-section">
        <div className="contact-image">
          <img src="assets/images/contact us.png" alt="Contact Us" />
        </div>
        <div className="contact-container">
          <h2 className="contact-title">Get in Touch</h2>
          <p className="contact-description">
            We’d love to hear from you! Please fill out the form below and send
            us your message.
          </p>

          <form ref={form} className="contact-form" onSubmit={sendEmail}>
            <label className="form-label">
              Name:
              <input
                type="text"
                name="user_name"
                className="form-input"
                placeholder="Your Name"
                required
              />
            </label>
            <label className="form-label">
              Email:
              <input
                type="email"
                name="user_email"
                className="form-input"
                placeholder="Your Email"
                required
              />
            </label>
            <label className="form-label">
              Subject:
              <input
                type="text"
                name="subject"
                className="form-input"
                placeholder="Your Subject"
                required
              />
            </label>
            <label className="form-label">
              Message:
              <textarea
                className="form-input form-textarea"
                placeholder="Your Message"
                name="message"
                required
              ></textarea>
            </label>
            <button type="submit" className="form-button">
              Send Message
            </button>
          </form>
        </div>
        <ToastContainer />
      </section>
    </>
  );
};

export default Contact;
